import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { EmailThread } from "app/pages/sales-intelligence/modules/ai-agent/types/email";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetEmailThreadById = ({ threadId }: { threadId: string | undefined }): UseQueryResult<EmailThread> => {
    return useQuery({
        queryKey: aiAgentQueryKeys.threadEmailById(threadId ?? ""),
        queryFn: () => salesApiService.aiAgent.email.getThreadById({ threadId: threadId ?? "" }),
        enabled: !!threadId,
    });
};
